export default {"src":"/_next/static/media/alchemy.bed79a0f.svg","height":30,"width":142,"blurWidth":0,"blurHeight":0};